// src/NavBar.js
import React from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function NavBar() {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/" className="mx-auto fw-bold fs-4">
          Flow State Yoga Retreats
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
          <Nav className="mx-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/about">About</Nav.Link>
            <Nav.Link as={Link} to="/contact">Contact</Nav.Link>

            <NavDropdown title="Retreats" id="retreats-dropdown">
              <NavDropdown.Item as={Link} to="/maldives-retreat">
                MALDIVES YOGA RETREAT 2026
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to="/himalayas-retreat">
                HIMALAYAS YOGA RETREAT 2026
              </NavDropdown.Item>
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;

